import { render, staticRenderFns } from "./SalesForce.vue?vue&type=template&id=40b34363&scoped=true"
import script from "./SalesForce.vue?vue&type=script&lang=js"
export * from "./SalesForce.vue?vue&type=script&lang=js"
import style0 from "./SalesForce.vue?vue&type=style&index=0&id=40b34363&prod&scoped=true&lang=css"
import style1 from "./SalesForce.vue?vue&type=style&index=1&id=40b34363&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b34363",
  null
  
)

export default component.exports